import moment from "moment";
import React from "react";
import Profile from "../../models/domain/Profile";
import SpaceMetadata from "../../models/domain/SpaceMetadata";

export default function AppointmentCard(props: {
  mainUserProfile: Profile;
  pid: string;
  appointmentDate: string | undefined;
  time: string | undefined;
  clinic: SpaceMetadata;
  doctorName: string;
  attendeeStatus: string | undefined;
  isOnline: boolean | undefined;
  therapy: string | undefined;
}) {
  //const userProfile = utils.retrieveUserProfile();
  return (
    <div className="">
      <div className="mt-1 border-bottom border-bottom">
        <div className="row d-flex align-items-start">
          <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-5 fieldcol">
            <span className="">Doctor </span>
          </div>
          <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-7 fieldcol">
            <span className="d-block text-end">{props.doctorName}</span>
          </div>
        </div>
      </div>
      <div className="mt-2 border-bottom">
        <div className="row d-flex align-items-start">
          <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-5 fieldcol">
            <span className="">Clinic </span>
          </div>
          <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-7 fieldcol">
            <span className=" d-block text-end">
              {props.clinic ? props.clinic.name : ""}
              {props.isOnline ? " - Online" : ""}
            </span>
          </div>
        </div>
      </div>
      {(props.appointmentDate != null || props.time != null) && (
        <div className="mt-2 border-bottom">
          <div className="row d-flex align-items-start">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-5 fieldcol">
              <span className="d-block">Date/Time </span>
            </div>
            <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-7 fieldcol">
              <span className="d-block text-end">
                {props.appointmentDate &&
                  moment(props.appointmentDate).isValid() &&
                  moment(props.appointmentDate).format("Do MMM YYYY")}

                {props.appointmentDate && props.time && ", "}

                {props.time && props.time}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
